/*
 * KS Textiles — hero slide click-through
 * v24 (2026-09-09)
 *
 * WHY v23 DID NOT WORK
 * The Sleek slideshow renders this structure per slide:
 *
 *   .swiper-slide
 *     .slideshow__item-wrap
 *       .slideshow__bg              <- the artwork
 *       .slideshow__content         <- absolutely positioned, covers the
 *                                      whole slide, holds title/button
 *
 * v23 appended the overlay link to .swiper-slide, so .slideshow__content
 * sat on top of it and absorbed every tap. On the KS slides that layer is
 * completely empty (no title, subheading, description or button — all the
 * text is painted into the artwork), so it was swallowing clicks for
 * nothing.
 *
 * THE FIX
 * 1. Append the overlay inside .slideshow__item-wrap at a high z-index.
 * 2. Set pointer-events:none on .slideshow__content, but ONLY for slides
 *    where it is genuinely empty. If the client later adds a real button
 *    in the theme editor, that slide is left completely alone.
 *
 * Target: /collections/all
 * Scope:  homepage only (loaded from layout/theme.liquid)
 */
(() => {
  const TARGET_URL = '/collections/all';
  const DRAG_TOLERANCE = 10;

  const SECTION_SELECTORS = [
    '.ks-mobile-slideshow',
    '.section--slideshow'
  ];

  function injectStyles() {
    if (document.getElementById('ks-hero-link-style')) return;

    const style = document.createElement('style');
    style.id = 'ks-hero-link-style';
    style.textContent = [
      '.ks-hero-link-host {',
      '  position: relative;',
      '}',
      /* Only neutralised on slides we have confirmed are empty. */
      '.ks-hero-link-host > .slideshow__content {',
      '  pointer-events: none;',
      '}',
      '.ks-hero-link {',
      '  position: absolute;',
      '  inset: 0;',
      '  z-index: 20;',
      '  display: block;',
      '  cursor: pointer;',
      '  background: transparent;',
      '  -webkit-tap-highlight-color: transparent;',
      '}',
      '.ks-hero-link:focus-visible {',
      '  outline: 3px solid rgba(255, 236, 191, 0.9);',
      '  outline-offset: -6px;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function findSlideshow() {
    for (const selector of SECTION_SELECTORS) {
      const found = document.querySelector(selector);
      if (found) return found;
    }
    return null;
  }

  /* A slide is safe to hijack only if its content layer has no real
     interactive element and no visible text of its own. */
  function contentLayerIsEmpty(wrap) {
    const content = wrap.querySelector(':scope > .slideshow__content');
    if (!content) return true;

    if (content.querySelector('a[href], button, input, select, textarea')) {
      return false;
    }

    return content.textContent.trim() === '';
  }

  function attachOverlay(wrap) {
    if (wrap.dataset.ksHeroLink) return;

    if (!contentLayerIsEmpty(wrap)) {
      /* Slide has its own button or copy — do not interfere. */
      wrap.dataset.ksHeroLink = 'skipped';
      return;
    }

    wrap.dataset.ksHeroLink = 'true';
    wrap.classList.add('ks-hero-link-host');

    const link = document.createElement('a');
    link.className = 'ks-hero-link';
    link.href = TARGET_URL;
    link.setAttribute('aria-label', 'Shop all KS Textiles products');

    let startX = 0;
    let startY = 0;
    let dragged = false;

    link.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      startY = event.clientY;
      dragged = false;
    });

    link.addEventListener('pointermove', (event) => {
      if (event.buttons === 0 && event.pointerType === 'mouse') return;

      const movedX = Math.abs(event.clientX - startX);
      const movedY = Math.abs(event.clientY - startY);

      if (movedX > DRAG_TOLERANCE || movedY > DRAG_TOLERANCE) {
        dragged = true;
      }
    });

    link.addEventListener('click', (event) => {
      if (dragged) {
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }
    });

    wrap.appendChild(link);
  }

  function run() {
    const section = findSlideshow();
    if (!section) return false;

    const wraps = section.querySelectorAll('.slideshow__item-wrap');
    if (!wraps.length) return false;

    injectStyles();
    wraps.forEach(attachOverlay);
    return true;
  }

  function boot() {
    if (run()) return;

    /* Swiper builds and clones slides after init, so poll briefly. */
    let attempts = 0;

    const timer = window.setInterval(() => {
      attempts += 1;

      if (run() || attempts > 20) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-apply after the theme editor re-renders the section. */
  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(run, 100);
  });
})();
